/*
 * @Author: your name
 * @Date: 2022-01-05 21:32:10
 * @LastEditTime: 2022-09-15 10:46:34
 * @LastEditors: qingqi qingqi@winning.com.cn
 * @Description:
 */
import Vue from 'vue'

//=========================第三方UI组件导入========================
import Element from 'element-ui' // element-ui
import 'element-ui/lib/theme-chalk/index.css'
import elementUILocale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import vDialogs from '@/common/components/Vdialog' // 弹出对话框
import 'babel-polyfill' // 解决IE10+兼容问题
import Fragment from 'vue-fragment' //空白根节点，减少dom层级
import BpDropdown from '@/common/components/BpDropdown'
import 'xe-utils'
import VXETable from 'vxe-table'
import './router/directives.js'

//=========================第三方lib组件导入========================
import moment from 'moment'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'
import eventBus from '@/frameworks/events/eventBus'

//=========================公司组件组件导入==========================
import WinDesign from 'win-design' //导入Windesin
import 'win-design/lib/themes/default.css'

import 'win-design/lib/themes/iconi.css'
import 'win-design/lib/themes/fonts/iconi.js'

import waterMark from '@winex-comp/common-water-mark'
import '@winex-comp/common-water-mark/lib/index.css'

//=========================第三方图标组件导入========================
import '@/common/icons' // icon
import '@/common/styles/index.scss' // global css
import '@/common/assets/bowtie-font/index.css' // global css
import '@/common/assets/iconfont/iconfont.css' // iconfont css
// flex 布局库
import 'flex.css'

import globalMixin from '@/common/mixins/global'

import adaptive from '@/common/directive/el-table'
import { requestApi } from '@/frameworks/http/services'

import App from './App'
import router from '@/frameworks/router'
import store from '@/frameworks/store'

// import "@/mock"; // simulation data
// import request from '@/frameworks/http/request'
// import * as filters from '@/common/filters' // global filters

// 引用打印组件
import Print from 'vue-print-nb'
Vue.use(Print)
// 预览图片组件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
})
// 全局组件注册
Vue.use(Element, {
  locale: elementUILocale,
  size: Cookies.get('size') || 'mini' // set element-ui default size
})
// 弹出对话框
Vue.use(vDialogs, {
  maxButton: false,
  closeTime: 3,
  store
})
VXETable.setup({
  table: {
    scrollX: {
      gt: 200 // 当大于指定条数时自动启用横向虚拟滚动，如果为 -1 则默认关闭虚拟滚动
    },
    scrollY: {
      gt: 60 // 当大于指定条数时自动启用纵向虚拟滚动，如果为 -1 则默认关闭虚拟滚动
    }
  }
})
Vue.use(VXETable)
Vue.use(Fragment.Plugin)
Vue.use(WinDesign)
Vue.use(BpDropdown)
Vue.use(adaptive)
Vue.mixin(globalMixin)
Vue.use(waterMark)

// register global utility filters.
// Object.keys(filters).forEach((key) => {
//   Vue.filter(key, filters[key])
// })

// 自定义插件
// 选择患者
// import selectPatient from '@/common/plugin/common/selectPatient.js'
// Vue.use(selectPatient)

// // 选择人员
// import selectUser from '@/common/plugin/common/selectUser.js'
// Vue.use(selectUser)

Vue.prototype.dayjs = dayjs
Vue.config.productionTip = false
Vue.prototype.$eventBus = eventBus
Vue.prototype.moment = moment
Vue.prototype.$requestApi = requestApi

new Vue({
  el: '#app',
  router,
  store,
  // i18n,
  render: (h) => h(App)
})
